
import { Vue, Component } from 'vue-property-decorator'
import VueLottiePlayer from 'vue-lottie-player'

@Component({
  name: 'MagicSortingModal',
  components: {
    VueLottiePlayer
  }
})
export default class MagicSortingModal extends Vue {}
